import React, { useCallback, useMemo, useState } from 'react';

import { Dialog } from '@mui/material';

import LoginForm from './components/LoginForm';
import useStyles from './styles';

export default function useLoginDialog(redirectUrl: string) {
    const { classes } = useStyles();

    const [isOpen, setIsOpen] = useState(false);

    const openDialog = useCallback(() => {
        setIsOpen(true);
    }, []);

    const closeDialog = useCallback(() => setIsOpen(false), []);

    const dialog = useMemo(() => {
        return (
            <Dialog open={isOpen} onClose={closeDialog} PaperProps={{ className: classes.paper }}>
                <LoginForm redirectUrl={redirectUrl} onSuccessLogin={closeDialog} />
            </Dialog>
        );
    }, [classes.paper, isOpen, closeDialog, redirectUrl]);

    return [dialog, openDialog] as const;
}
